// 21.03.03 front token 추가

//types
export const TOKEN = 'TOKEN';

//setter
export const setToken = userToken => ({ type: TOKEN, userToken});
